import { signalStore, withComputed, withState } from "@ngrx/signals";

interface FloatState {
    inline: boolean;
}

export const FloatStore = signalStore(
    withState<FloatState>({
        inline: false,
    }),
    withComputed((store) => ({
        onBody: () => !store.inline(),
    })),
);
